import {BuildingOffice2Icon, MapPinIcon} from "@heroicons/react/16/solid";
import {UserProcessTag} from "@ots-frontend/ots-data";
import {ReactNode} from "react";
import {OtsBadge} from "../components/OtsBadge";
import {OtsTransportCategoryIcon} from "../components/OtsTransportCategoryIcon";

export type ProcessTagsProps = {
  tags?: UserProcessTag[];
  className?: string;
};

const iconFor = (tag: UserProcessTag): ReactNode => {
  switch (tag.kind) {
    case "category":
      return <OtsTransportCategoryIcon category={tag.value}/>;
    case "region":
      return <MapPinIcon className="text-[var(--ots-text-muted)]"/>;
    case "company":
      return <BuildingOffice2Icon className="text-[var(--ots-text-muted)]"/>;
    default:
      return undefined;
  }
};

/**
 * The facts a handler gave about a process's input, as quiet chips: region, product, company, and options that
 * change what it does. Unknown kinds still show, without an icon.
 */
export const ProcessTags = ({tags, className}: ProcessTagsProps) => {
  if (!tags || tags.length === 0) return null;

  return <ul aria-label="Details" className={["flex flex-wrap items-center gap-1", className].filter(Boolean).join(" ")}>
    {tags.map((tag, index) => <li key={`${tag.kind}-${tag.label}-${index}`} data-kind={tag.kind}>
      <OtsBadge
        size="compact"
        tone={tag.kind === "flag" ? "indigo" : "neutral"}
        icon={iconFor(tag)}>
        {tag.label}
      </OtsBadge>
    </li>)}
  </ul>;
};
